import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import TextInput from "./../../utility-v1/TextInput";
import SelectBox from "./../../utility-v1/SelectBox";
import { FONT_FAMILY } from "../../config/themeConstants"; // Import FONT_FAMILY

import { indianStates } from "../../config/constantselections";

const DeliveryDetails = ({ form, handleChange, isEditMode, errors }) => {
  const getStateLabel = (value) => {
    const state = indianStates.find((state) => state.value === value);
    return state ? state.label : "";
  };

  return (
    <Box>
      <Typography
        sx={{
          fontFamily: FONT_FAMILY,
          fontSize: "16px",
          fontWeight: 600,
          marginBottom: { xs: "20px", lg: "25px" },
        }}
      >
        {isEditMode ? "Preview Delivery Details" : "Enter Delivery Details"}
      </Typography>

      <Grid container spacing={3}>
        {!isEditMode ? (
          <>
            <Grid item xs={12}>
              <TextInput
                label="Full Name"
                name="name"
                value={form.name}
                onChange={handleChange}
                error={errors.name}
                helperText={errors.name && "Enter full name."}
              />
            </Grid>

            <Grid item xs={6}>
              <TextInput
                label="Address"
                name="buyerDetails"
                value={form.buyerDetails}
                onChange={handleChange}
                multiline
                rows={5}
                error={errors.buyerDetails}
                helperText={errors.buyerDetails && "Enter address."}
              />
            </Grid>
            <Grid item xs={6}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextInput
                    label="Pin Code"
                    name="pincode"
                    value={form.pincode}
                    onChange={handleChange}
                    error={errors.pincode}
                    helperText={errors.pincode && "Enter pincode."}
                  />
                </Grid>
                <Grid item xs={12}>
                  <SelectBox
                    label="States"
                    value={form.state}
                    name="state"
                    onChange={handleChange}
                    options={indianStates}
                    error={errors.state}
                    helperText={errors.state && "Enter state."}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <TextInput
                label="Phone Number"
                name="phoneNumber"
                value={form.phoneNumber}
                onChange={handleChange}
                error={!!errors.phoneNumber} // ✅ Show error only if there is one
                helperText={errors.phoneNumber} // ✅ Dynamic error message
                inputProps={{ maxLength: 10 }} // ✅ Prevents user from typing more than 10 digits
              />
            </Grid>
            <Grid item xs={6}>
              <TextInput
                label="Email"
                name="email"
                value={form.email}
                onChange={handleChange}
                error={!!errors.email} // ✅ Show error only if there is one
                helperText={errors.email} // ✅ Dynamic error message
              />
            </Grid>
          </>
        ) : (
          <>
            <Grid item xs={12}>
              <Box
                sx={{
                  p: 3,
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  backgroundColor: "#fafafa",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography
                      sx={{
                        fontFamily: FONT_FAMILY,
                        fontSize: "17px",
                        fontWeight: 600,
                      }}
                    >
                      Name:
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: FONT_FAMILY,
                        fontSize: "17px",
                        fontWeight: 400,
                      }}
                    >
                      {form.name || "N/A"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      sx={{
                        fontFamily: FONT_FAMILY,
                        fontSize: "17px",
                        fontWeight: 600,
                      }}
                    >
                      Address:
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: FONT_FAMILY,
                        fontSize: "17px",
                        fontWeight: 400,
                      }}
                    >
                      {form.buyerDetails || "N/A"}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      sx={{
                        fontFamily: FONT_FAMILY,
                        fontSize: "17px",
                        fontWeight: 600,
                      }}
                    >
                      Pin Code:
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: FONT_FAMILY,
                        fontSize: "17px",
                        fontWeight: 400,
                      }}
                    >
                      {form.pincode || "N/A"}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      sx={{
                        fontFamily: FONT_FAMILY,
                        fontSize: "17px",
                        fontWeight: 600,
                      }}
                    >
                      State:
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: FONT_FAMILY,
                        fontSize: "17px",
                        fontWeight: 400,
                      }}
                    >
                      {getStateLabel(form.state) || "N/A"}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      sx={{
                        fontFamily: FONT_FAMILY,
                        fontSize: "17px",
                        fontWeight: 600,
                      }}
                    >
                      Phone Number:
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: FONT_FAMILY,
                        fontSize: "17px",
                        fontWeight: 500,
                      }}
                    >
                      {form.phoneNumber || "N/A"}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      sx={{
                        fontFamily: FONT_FAMILY,
                        fontSize: "17px",
                        fontWeight: 600,
                      }}
                    >
                      Email:
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: FONT_FAMILY,
                        fontSize: "17px",
                        fontWeight: 400,
                      }}
                    >
                      {form.email || "N/A"}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </>
        )}
      </Grid>
    </Box>
  );
};

export default DeliveryDetails;
